import {AbstractEvent} from "@/modules/base/events";
import {Stadium} from "@/modules/stadium/entity";

export class AfterFoundationFinishedEvent extends AbstractEvent {
  constructor(
    public stadium: Stadium,
  ) {
    super();
  }
}